import { render, staticRenderFns } from "./AlertsCard.vue?vue&type=template&id=8ccf8746"
import script from "./AlertsCard.vue?vue&type=script&lang=js"
export * from "./AlertsCard.vue?vue&type=script&lang=js"
import style0 from "./AlertsCard.vue?vue&type=style&index=0&id=8ccf8746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports